<template>
    <VContainer>
        <!-- Note that 'ref' is important here (value can be anything). read the description about `ref` below. -->
        <vue-croppie
                v-if="!cropped"
                ref="croppieRef"
                :enableOrientation="true"
                :enableResize="false"
                :boundary="{ width: 300, height: 300}"
                @result="result"
                @update="update">
        </vue-croppie>

        <!-- the result -->
        <v-layout v-else>
            <v-flex class="text-center">
                <img v-bind:src="cropped" >
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-flex xs12>
                <v-form ref="form">
                    <v-file-input :clearable="false"  label="Select" ref="file" type="file" accept="image/*" @change="imgbind($event)" ></v-file-input>
                </v-form>
            </v-flex>
        </v-layout>

        <v-layout class="text-center" v-if="binded">
            <v-flex>
                <v-btn :color="$store.state.colorhex" text  @click="rotate(90)">
                    <v-icon style="transform: scaleX(-1)">fa fa-redo</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn large :color="$store.state.colorhex" text  @click="crop()" >
                    <v-icon large>far fa-save</v-icon>
                </v-btn>
            </v-flex>
            <v-flex >
                <v-btn large :color="$store.state.colorhex" v-if="1==2" text @click="reset()">
                    <v-icon large>{{$store.state.icons.close}}</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn  :color="$store.state.colorhex" text   @click="rotate(-90)">
                    <v-icon>fa fa-redo</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <!--<button @click="bind()">Bind</button>-->
        <!-- Rotate angle is Number -->
        <!--<button @click="rotate(-90)">Rotate Left</button>-->
        <!--<button @click="rotate(90)">Rotate Right</button>-->
        <!--<button @click="crop()">Crop Via Callback</button>-->
        <!--<button @click="cropViaEvent()">Crop Via Event</button>-->
    </VContainer>
</template>

<style scoped>
    .hidden{
        display:none
    }
</style>

<script>
  export default {
    mounted() {
      // Upon mounting of the component, we accessed the .bind({...})
      // function to put an initial image on the canvas.
      // this.$refs.croppieRef.bind({
      //   url: 'http://i.imgur.com/Fq2DMeH.jpg',
      // })
    },
    data() {
      return {
        binded:false,
        cropped: null,
        images: [
          'http://i.imgur.com/fHNtPXX.jpg',
          'http://i.imgur.com/ecMUngU.jpg',
          'http://i.imgur.com/7oO6zrh.jpg',
          'http://i.imgur.com/miVkBH2.jpg'
        ]
      }
    },
    methods: {
      imgbind($event) {
        if(!$event)return
        var reader = new FileReader();
        var em = this;
        em.hide = false;
        em.preload = false //hacky
        em.cropped = null
        em.uploaded = true
        em.progress = 0
        reader.onload = function(e){
          em.$refs.croppieRef.bind({
            url: e.target.result
          });
          em.binded=true
        }
        reader.readAsDataURL($event);
      },
      bind() {
        // Randomize cat photos, nothing special here.
        let url = this.images[Math.floor(Math.random() * 4)]

        // Just like what we did with .bind({...}) on
        // the mounted() function above.
        this.$refs.croppieRef.bind({
          url: url,
        });
      },
      // CALBACK USAGE
      crop() {
        // Here we are getting the result via callback function
        // and set the result to this.cropped which is being
        // used to display the result above.
        let options = {
          format: 'jpeg',
          circle: false
        }
        let em = this;
        em.$refs.croppieRef.result(options, (output) => {
          em.cropped = output;
          em.binded=false
          em.$refs.form.reset()
        });
      },
      // EVENT USAGE
      cropViaEvent() {
        this.$refs.croppieRef.result(options);
      },
      result(output) {
        this.cropped = output;
      },
      update(val) {
        //console.log(val);
      },
      rotate(rotationAngle) {
        // Rotates the image
        this.$refs.croppieRef.rotate(rotationAngle);
      },
      reset(){
        this.cropped = null
        this.$refs.form.reset()
      },
    }
  }
</script>